import { User, UserRole } from '../../models/User';

export interface BaseUserDTO {
  id: string;
  partnerId: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  userRole: UserRole;
  authId: string;
  createdAt: string;
}

export const userExtension = (dto: BaseUserDTO): User => {
  return { ...dto };
};
